// AdminPanel.js
import React, { useEffect, useState } from "react";
import { db } from "../firebase"; // Import Firestore instance
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore"; // Import Firestore functions

const AdminPanel = () => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query

  // Fetch all user submissions
  const fetchSubmissions = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "joyousApplications"));
      const submissionsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSubmissions(submissionsData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching submissions:", error);
      setLoading(false);
    }
  };

  // Delete a submission by ID
  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "joyousApplications", id));
      setSubmissions(submissions.filter((submission) => submission.id !== id));
    } catch (error) {
      console.error("Error deleting submission:", error);
    }
  };

  // Handle search input changes
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filter submissions based on the search query
  const filteredSubmissions = submissions.filter(
    (submission) =>
      submission.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
      submission.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    fetchSubmissions();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <h1>Admin Panel</h1>
      {/* Search Bar */}
      <input
        type="text"
        value={searchQuery}
        onChange={handleSearch}
        placeholder="Search by username or name"
      />
      {/* Table for displaying submissions */}
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Address</th>
            <th>Role</th>
            <th>Username</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredSubmissions.length === 0 ? (
            <tr>
              <td colSpan="5">No submissions found</td>
            </tr>
          ) : (
            filteredSubmissions.map((submission) => (
              <tr key={submission.id}>
                <td>{submission.name}</td>
                <td>{submission.address}</td>
                <td>{submission.role}</td>
                <td>{submission.username}</td>
                <td>
                  {/* Delete Button */}
                  <button onClick={() => handleDelete(submission.id)}>Delete</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AdminPanel;







